import React from "react";
import { Box } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
    root: {
        padding: '100px 40px 0 40px',
        backgroundColor: ({ backgroundColor }) => backgroundColor || 'white', // Используйте backgroundColor из пропс, если он определен, иначе используйте "white"
        paddingTop: ({ paddingTop }) => paddingTop,
        marginBottom: ({ marginBottom }) => marginBottom,
        paddingBottom: ({ paddingBottom }) => paddingBottom,
        height: ({ height }) => height,
        [theme.breakpoints.down('sm')]: {
            padding: '60px 20px 0 20px'
        },
        [theme.breakpoints.up('lg')]: {
            padding: '100px 100px 0 100px'
        },
        [theme.breakpoints.up('xl')]: {
            padding: '100px 150px 0 150px'
        }
    },
}));

const SectionWrapper = ({ children, id, paddingTop, backgroundColor, marginBottom, paddingBottom, height }) => {
    const classes = useStyles({ paddingTop, backgroundColor, marginBottom, height, paddingBottom });

    return (
        <Box id={id} className={classes.root}>
            {children}
        </Box>
    );
};

export default SectionWrapper;

